<template>
  <div class="step-navigation-wrapper">
    <div class="step-navigation-scroll">
      <ul class="step-navigation">
        <li
          v-for="(step, index) in steps"
          :key="step.Id"
          class="step-navigation__item"
          :class="[ (currentStepIndex === index ? 'is--current' : ''), (step.IsComplete ? 'is--completed' : '') ]"
          v-show="step.Type !== 'subGoal'"
        >
          <button class="step-navigation__button" v-if="step.IsComplete" v-on:click="goToStep(index)">
            <span class="step-navigation__item__title">{{ step.Title }}</span>
          </button>
          <span v-else class="step-navigation__item__title">{{ step.Title }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import { mapState, mapMutations } from 'vuex';
//
@Component({
    props: {
    },
    computed: {
      ...mapState({
          currentStepIndex: state => state.buyGuide.currentStepIndex,
          steps: state => state.buyGuide.steps,
          status: state => state.buyGuide.status,
          results: state => state.buyGuide.results
      }),
    },
    components: {
    },
    methods: {
      ...mapMutations([
        'buyGuide/setCurrentStepIndex',
      ]),
    }
})
export default class StepNavigation extends Vue {
  // @Prop() steps;

  created() {
    // console.log('StepNavigation created');
  }

  mounted() {
  }

  goToStep(index) {
    this.$store.commit(
      'buyGuide/setCurrentStepIndex', {
        currentStepIndex: index
      }
    )
  }

}

</script>

<style>

</style>
